import { Link } from 'react-router-dom'

interface NotFoundProps {
  onLogout: () => void
}

function NotFound({ onLogout }: NotFoundProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="bg-white rounded-xl shadow-xl p-8 text-center max-w-md">
        <div className="text-6xl text-gray-300 mb-4">404</div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Seite nicht gefunden</h1>
        <p className="text-gray-600 mb-6">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <div className="space-y-3">
          <Link
            to="/dashboard"
            className="block w-full bg-blue-600 text-white font-medium py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Zum Dashboard
          </Link>
          <Link
            to="/chats"
            className="block w-full bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Zu den Chats
          </Link>
          <button
            onClick={onLogout}
            className="block w-full text-gray-500 hover:text-gray-700 transition-colors text-sm"
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound